// The PAYMENT SCHEDULE of an invoice (db/797): one row per distinct due date READ from receivables (finance date + payment days of every billed
// entry), the deliveries behind it, the amount due that day; rows sum to the invoice total. Used by the review drawer and the quick view (the
// document renders the same rows: lib/invoiceHtml renderScheduleBlock). Reusable for the customer statement (step I-2).
import React from 'react';
import { formatDate, formatMoneyExact } from '../../../utils/format';
import { sumText, schedMixed } from './invoicingModel.mjs';

export const dueRange = (sched) => {
  const ds = [...new Set((sched || []).map(x => x.due_date).filter(Boolean))].sort();
  return ds.length ? (ds.length > 1 ? `${formatDate(ds[0])} – ${formatDate(ds[ds.length - 1])}` : formatDate(ds[0])) : null;
};
const entry = (e, t) => (e.kind === 'order_level' ? t('schedOrderLevel') : e.kind === 'at_sale' ? t('blAtSale')
  : `${e.dispatch_no || t('blDirect')}${e.delivery_date ? ` · ${formatDate(e.delivery_date)}` : ''}`);
// db/950: a row's composition (goods per delivery, one line per fee share, discount slices) with the amounts; a schedule frozen before 950
// has no components -> its entries (deliveries only)
const comp = (c, t) => (c.kind === 'goods' ? entry({ ...c, kind: c.entry_kind }, t) : `${t(c.kind === 'fee' ? 'schedFee' : 'schedDisc')} · ${c.label || '—'}${c.description ? ` (${c.description})` : ''}`);
const what = (x, t) => (Array.isArray(x.components) && x.components.length
  ? x.components.map((c, k) => <div key={k} className="sched-comp" data-testid="sched-comp"><span>{comp(c, t)}</span><span className="num">{formatMoneyExact(c.amount)}</span></div>)
  : (x.entries || []).map((e, k) => <div key={k}>{entry(e, t)}</div>));

export default function ScheduleTable({ sched, t, testid = 'inv-schedule' }) {
  if (!Array.isArray(sched) || !sched.length) return null;
  return (
    <div className="gtable-wrap wrap"><table className="gtable zebra" data-testid={testid}>
      <thead><tr><th>{t('schedDue')}</th><th>{t(schedMixed(sched) ? 'schedWhatMix' : 'schedWhat')}</th><th className="r">{t('schedAmount')}</th></tr></thead>
      <tbody>{sched.map((x, i) => (
        <tr key={x.due_date || `o${i}`}><td style={{ whiteSpace: 'nowrap' }}>{x.due_date ? formatDate(x.due_date) : '—'}{x.aged_from_date && <span className="sub">{t('schedAged')}</span>}</td>
          <td className="mono" style={{ fontSize: 11.5 }}>{what(x, t)}</td>
          <td className="r num">{formatMoneyExact(x.amount)}</td></tr>))}</tbody>
      <tfoot><tr><td colSpan={2}>{t('schedTotal')}</td><td className="r num">{formatMoneyExact(sumText(sched, x => x.amount))}</td></tr></tfoot>
    </table></div>
  );
}
